import { Grid } from "@material-ui/core";
import { lang } from "i18nLang";
import {
  ButtonPadding,
  CheckCircleIconGreen,
  GridDetails,
  Message,
  Title,
} from "./style";

interface IPropsCompleted {
  /** Função que será executada ao fechar o Layer de Completado */
  onClose: any;
  /** Mensagem do estado */
  message: string;
  /** Detalhes da finalização */
  detailMessage: string;
}

/** Etapa que exibe a mensagem de importação finalizada com sucesso.
 * @category Components
 */
const CompletedLayer = (props: IPropsCompleted) => (
  <Grid
    container
    direction="column"
    justifyContent="center"
    alignItems="center"
  >
    <Grid item>
      <CheckCircleIconGreen />
    </Grid>
    <GridDetails item>
      <Title>{props.message}</Title>
    </GridDetails>
    <GridDetails item xs={6}>
      <Message variant="caption">{props.detailMessage}</Message>
    </GridDetails>
    <Grid item>
      <ButtonPadding color="primary" onClick={props.onClose}>
        {lang("finish")}
      </ButtonPadding>
    </Grid>
  </Grid>
);

export default CompletedLayer;
